import { render, staticRenderFns } from "./WarningBasic.vue?vue&type=template&id=5876cbfe&scoped=true&"
import script from "./WarningBasic.vue?vue&type=script&lang=js&"
export * from "./WarningBasic.vue?vue&type=script&lang=js&"
import style0 from "./WarningBasic.vue?vue&type=style&index=0&id=5876cbfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5876cbfe",
  null
  
)

export default component.exports